import React from 'react';

const Vue_Exercises = () => {
  return (
    <div>
      <h1>Vue_Exercises Component</h1>
      <p>This is the Vue_Exercises tutorial page.</p>
    </div>
  );
}

export default Vue_Exercises;
